import { createContext } from 'react'
import type {
  OrderCustomerInfo,
  OrderDetailCommon,
  OrderDetailRaw,
  OrderDetailResult,
  OrderDetailSource,
  OrderLoyaltyActivityResult,
  OrderTimelineEntry,
} from '../../../types'

export interface OrderDetailContextValue {
  storeId: string
  orderId: string
  isPos: boolean
  source: OrderDetailSource | undefined

  order: OrderDetailResult | null
  common: OrderDetailCommon | null
  raw: OrderDetailRaw | null
  isLoading: boolean
  isFetching: boolean
  isError: boolean
  error: unknown
  refetch: () => void

  // Web-only companion data (empty for POS orders).
  timeline: OrderTimelineEntry[]
  isTimelineLoading: boolean
  customer: OrderCustomerInfo | null
  isCustomerLoading: boolean
  loyaltyActivity: OrderLoyaltyActivityResult | null
  isLoyaltyLoading: boolean

  // Dismiss the failed-order alert (web orders only).
  dismissOrder: () => void
  isDismissing: boolean

  onBack?: () => void
}

export const OrderDetailContext = createContext<OrderDetailContextValue | null>(
  null,
)
